export default {
  hordeEnergyToStr: '每当前能量 +{0} 力量',
  hordeEnergyToEnergyReg: '每丢失能量 +{0} 能量再生',
  hordeManaToHaste: '+{0} 急速基于每当前法力值',
  hordeEnergyOnCrit: '暴击时 +{0} 能量',
  hordeHealOnCrit: '暴击时治愈 {0} 最大生命值',
  hordeRestoreCooldownOnCrit: '暴击时减少冷却 {0}',
  hordeBloodOnCrit: '暴击时获得 {0} 敌人血液',
  hordeManaRest: '在不使用 {0} 的激活后获得 {1} 的法力回复',
  hordeManasteal: '击杀时获得 {0} 法力',
  hordePassiveRecovery: '每秒应用 {0} 恢复',
  hordeActiveDamageCrit: '伤害性活动可以在 {0} 效率下暴击',
  hordeActiveHealCrit: '治疗活动可以以 {0} 的效率暴击',
  hordeFirstStrikeStun: '第一击也会眩晕 {0}',
  hordeSpellbladeOnActive: '战斗活动触发法术之刃 {0} 次',
  hordeCritOnNonCrit: '获得 +{0}* 暴击几率，当你的常规攻击不产生暴击时。这个效果可以叠加，但是当你暴击时重置',
  hordeStunOnCrit: '暴击有5%的几率击晕 {0}',
  hordeReviveDivisionShield: '恢复 {0} 你的分裂盾在复活的时候',
  hordeReduceAttackOnAttack: '降低敌人攻击 {0} 对于普通攻击, 最多叠加 {1} 次',
  hordeAttackAfterTime: '在同一场战斗中每分钟获得+{0}次攻击',
  hordeStrIntAfterTime: '在同一战斗中每分钟获得{0}力量和智力',
  hordeFirstAttacksCrit: '第一次 {0} 攻击必暴击',
  hordeFastKillBonusBlood: '获得 +{0} 血液，如果你在5秒或更短时间内击杀敌人',
  hordeAttackPerMissingHealth: '获得 +{0} 攻击，每1%的生命值丢失',
  hordeStrIntPerMissingHealth: '获得 {0} 力量和智力，每1%的生命值丢失',
  galleryBonusTier1Idea: '+{0} 等级对于所有层级 1 想法',
}
